import { useState, useEffect, useRef,  } from 'react';
import Pusher from 'pusher-js';
import { makeStyles} from '@material-ui/core/styles';
import { Paper, TextField, IconButton } from '@material-ui/core';
import SendIcon from '@mui/icons-material/Send';

import {v4} from 'uuid';
const pusher = new Pusher('90d6599bf3d6cae8a74d', {
  cluster: 'ap3',
  encrypted: true
});

const channel = pusher.subscribe('chat');
var ready_cnt = 0;


const useStyles = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(2),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderRadius: '20px', // add border radius

    },
    messages: {
      flexGrow: 1,
      maxHeight: 250, // set the desired height value
      overflowY: 'auto', // disable default scrolling
      padding: theme.spacing(2),
    },
    message: {
      marginBottom: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
    },
    messageText: {
      marginTop: theme.spacing(1),
    },
    input: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
}));

export default function Chat() {
  const classes = useStyles();
  const messagesRef = useRef(null); // add this line

  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [uid, setUid] = useState(0);

  useEffect(initializeComponent, []);

  useEffect(() => {
    messagesRef.current.scrollTop = messagesRef.current.scrollHeight; // add this line
  }, [messages]);

  function handleChange(event) {
    setMessage(event.target.value);
  }

  function handleSubmit(event) {
    if(message == '') return;
    console.log('handle submit')
    fetch('/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, uid })
    });
    setMessage('');
  }

  function initializeComponent() {
    // Code to run on component mount goes here
    ready_cnt++;
    if(ready_cnt == 1) {
        setUid(v4());
        console.log('chat mounted!');
        channel.bind('message', ({ message, uid }) => {
            console.log('message', message, uid);
            setMessages((prevMessages) => {
              var t =  [...prevMessages, {text: message, fromUser:uid}];
              return t;
            });
        });
    }
  }


  return (
    <Paper className={`${classes.root} mt-4`}>
      <div className="messages" style={{ flexGrow:1,padding:"2rem", paddingBottom:"0.1rem", height: "250px", overflowY: "scroll" }} ref={messagesRef}>
        {messages.map((message, idx) => (
          <div key={idx} className={`${classes.message} border-test`}>
            <div>{message.fromUser == uid ? '나' : '사용자'}</div>
            <div className={classes.messageText}>{message.text}</div>
          </div>
        ))}
      </div>
      <div className="flex item-center p-2">
        <TextField
          variant="outlined"
            label="메시지를 입력하세요"
          fullWidth
          value={message}
          onChange={handleChange}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter') {
              handleSubmit();
              ev.preventDefault();
                }}}
        />
        <IconButton onClick={handleSubmit}>
        <SendIcon />
        </IconButton>        
      </div>
    </Paper>
  );
}
